var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-frappe',{attrs:{"id":"test","labels":_vm.labels,"title":"Schrtte","type":"axis-mixed","height":300,"colors":['purple'],"dataSets":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }